function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import React, { useState } from 'react';
import { Form, Card, Table } from 'react-bootstrap';
const ThemeModal = _ref => {
  let {
    show,
    title,
    onHide,
    onSubmit
  } = _ref;
  const [theme, setTheme] = useState({
    name: ''
  });
  const handleChange = event => {
    const value = event.target.value;
    setTheme(_objectSpread(_objectSpread({}, theme), {}, {
      [event.target.name]: value
    }));
  };
  const modalBody = () => {
    return /*#__PURE__*/React.createElement(Card, {
      className: "mt-3"
    }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Table, {
      className: "table-bordered"
    }, /*#__PURE__*/React.createElement("tbody", {
      "data-testid": "clientContactModalBody"
    }, /*#__PURE__*/React.createElement("tr", {
      className: "text-primary app-fs-table-header"
    }, /*#__PURE__*/React.createElement("th", {
      className: "border-0 font-weight-normal",
      style: {
        width: '20%'
      }
    }, "Name")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Control, {
      value: theme.name,
      name: "name",
      onChange: handleChange,
      size: "md",
      type: "text"
    })))))));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    size: "xl",
    title: title,
    show: show,
    renderBody: () => modalBody(),
    onHide: onHide,
    onSubmit: () => onSubmit(theme)
  });
};
export default ThemeModal;